type DrawerVariant = 'temporary' | 'persistent';
export type ScreenSize = 'small' | 'medium' | 'large';

export type RailState = {
  primaryRailOpen: boolean;
  primaryRailCompact: boolean;
  drawerVariant: DrawerVariant;
  hasSecondaryRail: boolean;
  allToolsOpen: boolean;
  learnOpen: boolean;
  screenSize: ScreenSize;
};

export type RailAction =
  | { type: 'setPrimaryRailOpen'; payload: boolean }
  | { type: 'setPrimaryRailCompact'; payload: boolean }
  | { type: 'setScreenSize'; payload: ScreenSize }
  | { type: 'setSecondaryRail'; payload: boolean }
  | { type: 'setAllTools'; payload: boolean }
  | { type: 'setLearn'; payload: boolean };

export const createInitialState = ({ screenSize }: { screenSize: ScreenSize }): RailState => {
  return {
    primaryRailOpen: screenSize === 'large',
    primaryRailCompact: false,
    drawerVariant: screenSize === 'large' ? 'persistent' : 'temporary',
    hasSecondaryRail: false,
    allToolsOpen: false,
    learnOpen: false,
    screenSize,
  };
};

function railReducer(state: RailState, action: RailAction): RailState {
  switch (action.type) {
    case 'setPrimaryRailOpen':
      if (action.payload) {
        return { ...state, primaryRailOpen: action.payload };
      }
      return { ...state, primaryRailOpen: action.payload, allToolsOpen: false, learnOpen: false };
    case 'setPrimaryRailCompact': {
      return { ...state, primaryRailCompact: action.payload };
    }
    case 'setScreenSize': {
      const drawerVariant = action.payload === 'large' ? 'persistent' : 'temporary';
      const primaryRailOpen = drawerVariant !== 'temporary';
      let { primaryRailCompact } = state;
      if (action.payload !== 'large') {
        primaryRailCompact = state.hasSecondaryRail;
      }

      return {
        ...state,
        allToolsOpen: false,
        learnOpen: false,
        drawerVariant,
        primaryRailCompact,
        primaryRailOpen,
        screenSize: action.payload,
      };
    }
    case 'setSecondaryRail': {
      const drawerVariant = state.screenSize === 'large' ? 'persistent' : 'temporary';

      return {
        ...state,
        drawerVariant,
        primaryRailCompact: action.payload,
        hasSecondaryRail: action.payload,
      };
    }
    case 'setAllTools': {
      let { learnOpen, primaryRailCompact } = state;
      if (action.payload) {
        learnOpen = false;
      }

      if (state.screenSize === 'small') {
        primaryRailCompact = action.payload || state.hasSecondaryRail;
      }

      return { ...state, primaryRailCompact, learnOpen, allToolsOpen: action.payload };
    }
    case 'setLearn': {
      let { allToolsOpen, primaryRailCompact } = state;
      if (action.payload) {
        allToolsOpen = false;
      }
      if (state.screenSize === 'small') {
        primaryRailCompact = action.payload || state.hasSecondaryRail;
      }

      return { ...state, primaryRailCompact, allToolsOpen, learnOpen: action.payload };
    }
    default:
      return state;
  }
}

export default railReducer;
